import { TableBar } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useCallback } from 'react';
import { changeOrderStatus } from '../../../api/order/changeOrderStatus';
import { Order as OrderType } from '../../../apiTypes';
import PrimaryButton from '../../../components/PrimaryButton';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';

type Props = {
  order: DbDocument<OrderType>;
};

const TableOrderBlock = ({ order }: Props) => {
  const { lang } = useLocale();
  const { worker } = useCafe();
  const { cafeSlug } = useAdmin();

  const handleConfirmOrder = useCallback(async () => {
    if (worker) {
      await changeOrderStatus({ order, worker, cafeSlug, newStatus: 'processing' });
    }
  }, [cafeSlug, order, worker]);

  return (
    <Box
      sx={{
        borderRadius: 1,
        bgcolor: (t) => `${t.palette.primary.main}11`,
        m: 1,
        p: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TableBar sx={{ color: (t) => t.palette.text.secondary, ml: 1 }} />
        <Typography color={(t) => t.palette.text.secondary}>{t.status_ordered[lang]}</Typography>
      </Box>

      <PrimaryButton variant="contained" onClick={handleConfirmOrder}>
        {t.confirm[lang]}
      </PrimaryButton>
    </Box>
  );
};

export default TableOrderBlock;
